// component for load more
(function () {
  if (!customElements.get("collection-grid")) {
    customElements.define(
      "collection-grid",
      class CollectionGrid extends HTMLElement {
        constructor() {
          super();
          const urlParams = new URLSearchParams(window.location.search);
          this.pageFromUrl = parseInt(urlParams.get("page") || "1");
          this.currentPage = this.pageFromUrl + 1;

          this.perPage = parseInt(this.dataset?.perPage || 18);
          this.totalCount = parseInt(this.dataset?.totalCount || 0);
          this.loadedCount = this.pageFromUrl * this.perPage;
          this.totalPages = this.dataset?.totalPages || 1;
          this.getNextProducts = this.getNextProducts.bind(this);

          this.loadMoreBtn = this.querySelector("#load-more-products");
          this.btnCounter = this.loadMoreBtn?.querySelector(".js-next-group");
          this.container = this.querySelector(".collection-grid");

          this.startPage = parseInt(
            new URLSearchParams(window.location.search).get("page") || "1"
          );
        }

        updateCurrentShown() {
          const fromEl = this.querySelector(".js-from");
          const toEl = this.querySelector(".js-to");

          const from = (this.startPage - 1) * this.perPage + 1;
          const to = this.loadedCount;

          if (fromEl) fromEl.textContent = from;
          if (toEl) toEl.textContent = to;
        }

        renderProducts(data) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, "text/html");
          const newContainer = doc.querySelector(".grid.collection-grid");
          const newProducts = newContainer.querySelectorAll(".grid-item");
          const fragment = document.createDocumentFragment();
          newProducts.forEach((el) => fragment.appendChild(el));
          this.container.appendChild(fragment);
        }

        updateUrlPageParam() {
          const url = new URL(window.location.href);
          url.searchParams.set("page", this.currentPage - 1);
          window.history.pushState({}, "", url.toString());
        }

        updateButtonText() {
          const remaining = this.totalCount - this.loadedCount;
          if (remaining <= 0) {
            this.loadMoreBtn?.remove();
            return;
          }

          const nextLoadCount = Math.min(this.perPage, remaining);
          this.btnCounter.innerText = nextLoadCount;
        }

        buildNextPageUrl() {
          const url = new URL(window.location.href);
          url.searchParams.set("page", this.currentPage);
          return url.toString();
        }

        async getNextProducts() {
          try {
            this.classList.add('loading');
            const nextPageUrl = this.buildNextPageUrl();
            const response = await fetch(nextPageUrl);
            const data = await response.text();

            this.currentPage += 1;
            this.loadedCount = Math.min(
              this.loadedCount + this.perPage,
              this.totalCount
            );

            this.updateButtonText();
            this.renderProducts(data);
            this.updateCurrentShown();
            this.updateUrlPageParam();
          } catch (error) {
            console.error("Error downloading next page:", error);
          } finally {
            this.classList.remove('loading');
          }
        }

        renderLoadPreviousButton(currentPage) {
          this.previousPage = currentPage - 1;
          this.startPage = Math.max(1, this.startPage - 1);

          const prevBtn = document.createElement("button");
          prevBtn.textContent = "Load previous";
          prevBtn.className = "load-previous-btn";
          prevBtn.style.marginBottom = "1rem";

          prevBtn.addEventListener("click", async () => {
            const pageToLoad = this.previousPage;
            if (pageToLoad < 1) return;

            const url = new URL(window.location.href);
            if (pageToLoad > 1) {
              url.searchParams.set("page", pageToLoad);
            } else {
              url.searchParams.delete("page");
            }

            try {
              const response = await fetch(url.toString());
              const data = await response.text();
              const parser = new DOMParser();
              const doc = parser.parseFromString(data, "text/html");
              const newContainer = doc.querySelector(".grid.collection-grid");
              const newProducts = newContainer.querySelectorAll(".grid-item");

              const fragment = document.createDocumentFragment();
              newProducts.forEach((el) => fragment.appendChild(el));
              this.container.prepend(fragment);
              this.updateCurrentShown();

              this.currentPage = pageToLoad + 1;
              this.previousPage -= 1;
              this.loadedCount = Math.min(
                this.loadedCount + this.perPage,
                this.totalCount
              );

              this.updateButtonText();
              window.history.pushState({}, "", url.toString());

              if (this.previousPage < 1) {
                prevBtn.remove();
              }
            } catch (error) {
              console.error("Error downloading previous page:", error);
            }
          });

          this.container.before(prevBtn);
        }

        connectedCallback() {
          this.loadMoreBtn?.addEventListener("click", this.getNextProducts);
          this.updateButtonText();
          this.updateCurrentShown();
          if (this.pageFromUrl > 1) {
            this.renderLoadPreviousButton(this.pageFromUrl);
          }
        }

        disconnectedCallback() {
          this.loadMoreBtn?.removeEventListener("click", this.getNextProducts);
        }
      }
    );
  }
})();
